import React, { Component } from 'react';
import { Redirect } from 'react-router';
import {  OrderInformation, SubNav, OrderConfirmationCustomerInformation } from './components.js'
import './confirmOrder.css';
import * as CONSTS from './consts.js';
import {clearSessionValue, storeSessionValue, readSessionValue, createUrlParams, parsePaymentMethods, calculateVatAmount} from './helper.js';
import axios from 'axios';
import { Images, MAKSUTURVA_URL } from './consts.js';

class ConfirmOrder extends Component {
  constructor() {
    super();
    this.state= {
      companyName: '',
      businessId : '',
      price: '',
      liters : '',
      combinationId: '',
      providerName: '',
      typeUse: '',
      businessCustomer: '',
      customerID: '',
      tasanTayteen: '',
      puhelinOhjeet: false,
      kirjallisetOhjeet: false,
      markkinointilupa: false,
      ohjeet: '',
      purkuOhjeet:'',
      paymentMethods: [],
      pmt_action: 'NEW_PAYMENT_EXTENDED',
      pmt_version: '0004',
      pmt_sellerid: '',
      pmt_id: '',
      pmt_orderid: '',
      pmt_reference: '',
      pmt_duedate: '',
      pmt_userlocale: 'fi_FI',
      pmt_amount: '',
      pmt_currency: 'EUR',
      pmt_okreturn: 'http://po.fi/payment/success',
      pmt_errorreturn: 'http://po.fi/payment/error',
      pmt_cancelreturn: 'http://po.fi/payment/cancel',
      pmt_delayedpayreturn: 'http://po.fi/payment/cancel',
      pmt_escrow: 'Y',
      pmt_escrowchangeallowed: 'N',
      pmt_invoicefromseller: 'N',
      pmt_paymentmethod: 'FI70',
      pmt_buyername: '',
      pmt_buyeraddress: '',
      pmt_buyerpostalcode: '',
      pmt_buyercity: '',
      pmt_buyercountry: '',
      pmt_buyerphone: '',
      pmt_buyeremail: '',
      pmt_deliveryname: '',
      pmt_deliveryaddress: '',
      pmt_deliverypostalcode: '',
      pmt_deliverycity: '',
      pmt_deliverycountry: 'FI',
      pmt_sellercosts: '',
      pmt_rows: '1',
      pmt_row_name1: '',
      pmt_row_desc1: '',
      pmt_row_quantity1: '',
      pmt_row_deliverydate1: '',
      pmt_row_price_gross1: '',
      pmt_row_vat1: '',
      pmt_row_discountpercentage1: '',
      pmt_row_type1: '',
      pmt_charset: 'UTF-8',
      pmt_charsethttp: 'UTF-8',
      pmt_hashversion: 'SHA-256',
      pmt_hash: '',
      pmt_keygeneration: '1',

    };

  }
  componentDidMount() {
    document.title = 'PÖ.fi | Vahvista tilaus';
    if (typeof this.props.location.state == 'undefined') {
      return (<Redirect to ="/" />);
    } else {

      this.setState({
        liters : this.props.location.state.liters,
        pmt_row_quantity1:this.props.location.state.liters,
        price:this.props.location.state.price,
        pmt_amount:this.props.location.state.price,
        combinationId: this.props.location.state.combinationId,
        providerName: this.props.location.state.providerName,
        tasanTayteen: this.props.location.state.tasanTayteen || 'tasan',
        puhelinOhjeet: this.props.location.state.puhelinOhjeet,
        kirjallisetOhjeet: this.props.location.state.kirjallisetOhjeet,
        purkuOhjeet: this.props.location.state.purkuOhjeet,
        markkinointilupa: this.props.location.state.markkinointilupa,
        pmt_buyername: `${this.props.location.state.firstName} ${this.props.location.state.lastName}`,
        pmt_buyercity: this.props.location.state.city,
        pmt_buyeraddress: this.props.location.state.address,
        pmt_buyerpostalcode: this.props.location.state.postcode,
        pmt_deliveryname : `${this.props.location.state.firstName} ${this.props.location.state.lastName}`,
        pmt_deliveryaddress: this.props.location.state.address,
        pmt_deliverycity: this.props.location.state.city,
        pmt_deliverypostalcode : this.props.location.state.postcode,
        pmt_buyerphone: this.props.location.state.phone,
        pmt_buyeremail: this.props.location.state.email,
        typeUse: this.props.location.state.typeUse,
        businessCustomer: this.props.location.state.businessCustomer,
        companyName : this.props.location.state.companyName,
        businessId : this.props.location.state.businessId,
        pmt_id : readSessionValue('pmt_id') || '',
      }, () =>  {

        let puhelinString = 'Puhelimitse';
        let kirjallinenString = 'Kirjallisesti';
        if (this.props.location.state.kirjallisetOhjeet) {
          if (this.props.location.state.puhelinOhjeet) {
            this.setState({ohjeet: kirjallinenString + ', ' + puhelinString});
          } else {
            this.setState({ohjeet: kirjallinenString});
          }
        } else if (this.props.location.state.puhelinOhjeet){
          this.setState({ohjeet: puhelinString});
          this.setState({purkuOhjeet: ''});
          this.props.location.state.purkuOhjeet = '';
        } else {
          this.setState({ohjeet: ''})
          this.setState({purkuOhjeet: ''});
          this.props.location.state.purkuOhjeet = '';
        }


      axios.post(`${CONSTS.API_URL}/get-price-point`,

        JSON.stringify({
        'liters': this.props.location.state.liters,
        'postcode': this.props.location.state.postcode,
        'combinationId': this.props.location.state.combinationId,
        'businessCustomer': this.props.location.state.businessCustomer,
        'typeUse': this.props.location.state.typeUse,
        'email' : this.props.location.state.email,
        'name' : `${this.props.location.state.firstName} ${this.props.location.state.lastName}`,
        'phone' : this.props.location.state.phone,
        'address' : this.props.location.state.address,
        'city' : this.props.location.state.city,
        'pmt_id' : readSessionValue('pmt_id') || '',
        'puhelin_ohjeet' : this.props.location.state.puhelinOhjeet || false,
        'kirjalliset_ohjeet': this.props.location.state.kirjallisetOhjeet || false,
        'purkuOhjeet' : this.props.location.state.purkuOhjeet,
        'tasan_tayteen' : this.props.location.state.tasanTayteen || 'tasan',
        'markkinointilupa' : this.props.location.state.markkinointilupa || false,
        'companyName' :this.props.location.state.companyName,
        'businessId' : this.props.location.state.businessId
        }))
        .then(res => {

          const pricePoint = JSON.parse(res.data);

          this.setState({
            pmt_amount: pricePoint.price,
             pmt_sellerid: pricePoint.sellerid,
              pmt_row_discountpercentage1:'0',
              pmt_id : pricePoint.pmt_id,
              customerID : pricePoint.customer_id,
            }, () => { storeSessionValue('pmt_id',pricePoint.pmt_id);

            axios.get(`${CONSTS.MAKSUTURVA_URL}/GetPaymentMethods.pmt?sellerid=${this.state.pmt_sellerid}&request_locale=fi&totalamount=${this.state.pmt_amount}`)
            .then(res => {
              this.setState({paymentMethods : parsePaymentMethods(res.data)});
            })
            .catch(res => {

            });
          });
        })
        .catch(res => {

        });


      });
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event' : 'checkout',
      'ecommerce' : {
        'checkout' : {
          'actionField' : {'step' : 2},
        }
      }
    });
}



inputRadioHandler = (e) => {
  const event = e
    this.setState({pmt_paymentmethod: event.target.value}, () => {

      this.createForm(this.state);
    });
}

handleInputChange = (e) => {

    this.setState({[e.target.name]: e.target.value});

  }

  createPaymentOptions = (options) => {
    let optionsArr = options.paymentMethods;

    if (this.state.tasanTayteen === 'tayteen' && optionsArr) {
      optionsArr = optionsArr.filter(item => item.code === "FI72" || item.code === "FI70" || item.code === "FI71")
    }

    const lang = options.language;
    if (!optionsArr) {
      return (<div></div>)
    }
    let optionsHTML = [];

    if (optionsArr.length === 0) {
      return(<div></div>)
    }

    // First filter all invoices, then based on busienss customer, so we can filter bank arr easily
    let invoiceArr = optionsArr.filter(item => item.code === "FI72" || item.code === "FI70" || item.code === "FI71")
    const bankArr = optionsArr.filter(item => !invoiceArr.includes(item))
    invoiceArr = invoiceArr.filter(item => {
      if (this.state.businessCustomer) return item.code === "FI72"
      else return item.code === "FI70" || item.code === "FI71"
    })

    const PaymentHTML = (props) => (
      <>
      <div className="row">
        <div className="text-left col-xs-12 col-xl-12">
            <h4>{props.title}</h4>
        </div>
      </div>
      <div className="row">
        <div className="text-left col-xs-12 col-xl-12">
            <h6>{props.subTitle}</h6>
        </div>
      </div>
        <div className="row">
          { props.children }
        </div>
      </>
    )
    const createChildren = arr => {
      const children = arr.map(item => {
        let currImage
        switch(item.code) {
          case "FI72":
            currImage=Images['Laskupainikkeet_Yrityslasku.png']
            break
          case "FI71":
            currImage = Images['Laskupainikkeet_Erämaksu.png']
            break
          case "FI70":
            currImage = Images['Laskupainikkeet_Lasku.png']
            break
          default:
            currImage = item.image.url
            break
        }
        return (
          <>
            <div key={item.code} className="payment-option-container">
              <button id={item.code} onClick={
                (e) => {
                  e.preventDefault();
                  e.persist();
                  this.setState({pmt_paymentmethod: e.currentTarget.value}, () => {
                    let data = JSON.stringify(this.state);

                    axios.post(`${CONSTS.API_URL}/create-maksuturva-form`, data)
                     .then(async (res) => {
                       const resData = JSON.parse(res.data);
                       this.setState(resData, ()=> {

                         clearSessionValue('pmt_id');
                         clearSessionValue('priceData');

                         // Use this to send a post request to api
                         //document.getElementById('payment-form').submit();

                         // Use this to send a get request to api
                         window.location.href = `${CONSTS.MAKSUTURVA_URL}/NewPaymentExtended.pmt?${createUrlParams(res.data)}`;

                       });

                     })
                     .catch(async (res) => {
                       return (<Redirect to ="/" />);
                     });

                  });

                }
              }
              type="submit" name="pmt_paymentmethod" value={item.code} >
                <img src={currImage} height={item.image.height} width={item.image.width} />
              </button>
            </div>
          </>
        )
      })
      return children
    }


    if (this.state.tasanTayteen === 'tayteen') {
      return (
        <div>
          <PaymentHTML title="Maksa myöhemmin">
            {createChildren(invoiceArr)}
          </PaymentHTML>
          <div className="row">
          <span>Etkö näe haluamaasi maksutapaa?</span>
          </div>
          <div className="row">
          <span><a href="javascript:void(0)" onClick={() => this.setState({tasanTayteen: 'tasan'})}>Saat näkyviin kaikki maksutavat vaihtamalla täytön tasan</a></span>
          </div>
        </div>
      )
    }

    return (
      <>
      <PaymentHTML title="Maksa myöhemmin:">
        {createChildren(invoiceArr)}
      </PaymentHTML>
      <PaymentHTML title="Maksa nyt verkkopankista:" subTitle="Mikäli toimitus on maksettua pienempi, niin ylimääräiset palautetaan">
        {createChildren(bankArr)}
      </PaymentHTML>
      </>
    )


}



async createForm(JSONData) {
    const data = JSON.stringify(JSONData);

    await axios.post(`${CONSTS.API_URL}/create-maksuturva-form`, data)
      .then((res) => {

        this.setState(JSON.parse(res.data), ()=> {

        });

      })
      .catch((res) => {
        return (<Redirect to ="/" />);
      });

  }

  render() {
    let orderComplete = this.state.orderSent;
    let paymentOptions = this.createPaymentOptions(this.state.paymentMethods);
    if (typeof this.props.location.state == 'undefined') {
      return (<Redirect to ="/" />);
    } else {
      if (orderComplete) {

      } else {
      return (
        <div className="body-container confirm-order-page">
        <div className="sub-nav">
            <SubNav currPage="confirmOrder" state={{
              businessCustomer: this.state.businessCustomer,
              combinationId: this.state.combinationId,
              liters: this.state.pmt_row_quantity1,
              postcode: this.state.pmt_buyerpostalcode,
              price: this.state.price,
              providerName: this.state.providerName,
              typeUse: this.state.typeUse,
              tasanTayteen: this.state.tasanTayteen,
              kirjallisetOhjeet: this.state.kirjallisetOhjeet,
              puhelinOhjeet: this.state.puhelinOhjeet,
              purkuOhjeet: this.state.purkuOhjeet,
              markkinointilupa: this.state.markkinointilupa,
            }}/>
        </div>
          <div className="order-title col-sm-12 col-md-12 col-lg-12">
            <h3>Tilauksen vahvistaminen</h3>
          </div>
        <div className="row">
          <div className="order-customer-information col-sm-12 col-md-6 col-lg-6">
            <OrderConfirmationCustomerInformation customerID={this.state.customerID} customerName={this.state.pmt_buyername}
            streetAddress={this.state.pmt_buyeraddress} postcode={this.state.pmt_buyerpostalcode} city={this.state.pmt_buyercity}
            phone={this.state.pmt_buyerphone} email={this.state.pmt_buyeremail} tasanTayteen={this.state.tasanTayteen === 'tasan' ? 'Tasan' : 'Täyteen (Huom. Vain laskulla ja erämaksulla)'}
            ohjeet={this.state.ohjeet} provider={this.state.providerName} purkuOhjeet={this.state.purkuOhjeet} companyName={this.state.companyName}
            />
          </div>
          <div className="order-information col-sm-12 col-md-6 col-lg-6">
            <div className="order-info-wrap">
              <OrderInformation providerName={this.state.providerName} postcode={this.state.pmt_buyerpostalcode} amount={this.state.liters}
              price={((this.state.price)*this.state.liters).toFixed(2)} city={this.state.pmt_buyercity}
              noVatPrice={calculateVatAmount((this.state.price)*this.state.liters, 24)[0].toFixed(2)}
              vatAmount={calculateVatAmount((this.state.price)*this.state.liters, 24)[1].toFixed(2)}
              typeUse={this.state.typeUse === 'lammityskaytto' ? 'Lämmityskäyttöön' : 'Moottorikäyttöön'}
              linkTo={{pathname: '/order', state:{
                businessCustomer: this.state.businessCustomer,
                combinationId: this.state.combinationId,
                liters: this.state.pmt_row_quantity1,
                postcode: this.state.pmt_buyerpostalcode,
                price: this.state.price,
                providerName: this.state.providerName,
                typeUse: this.state.typeUse,
                tasanTayteen: this.state.tasanTayteen,
                kirjallisetOhjeet: this.state.kirjallisetOhjeet,
                puhelinOhjeet: this.state.puhelinOhjeet,
                purkuOhjeet: this.state.purkuOhjeet,
                markkinointilupa: this.state.markkinointilupa,
              }}} linkText='Muuta toimitustietoja'/>
            </div>
          </div>
        </div>


          <div className="order-title row">
            <div className="col-xs-12 col-xl-12">
              <h3>Miten haluaisit maksaa?</h3>
            </div>
          </div>

    <form id="payment-form" action={MAKSUTURVA_URL+"/NewPaymentExtended.pmt"}>

        <div className="row top-buffer-small"></div>

    {paymentOptions}



    <input type="hidden" name="pmt_action"                     value={this.state.pmt_action} />
    <input type="hidden" name="pmt_version"                    value={this.state.pmt_version} />
    <input type="hidden" name="pmt_sellerid"                   value={this.state.pmt_sellerid} />
    <input type="hidden" name="pmt_id"                         value={this.state.pmt_id} />
    <input type="hidden" name="pmt_orderid"                    value={this.state.pmt_orderid} />
    <input type="hidden" name="pmt_reference"                  value={this.state.pmt_reference} />
    <input type="hidden" name="pmt_duedate"                    value={this.state.pmt_duedate} />
    <input type="hidden" name="pmt_userlocale"                 value={this.state.pmt_userlocale} />
    <input type="hidden" name="pmt_amount"                     value={this.state.pmt_amount} />
    <input type="hidden" name="pmt_currency"                   value={this.state.pmt_currency} />
    <input type="hidden" name="pmt_okreturn"                   value={this.state.pmt_okreturn} />
    <input type="hidden" name="pmt_errorreturn"                value={this.state.pmt_errorreturn} />
    <input type="hidden" name="pmt_cancelreturn"               value={this.state.pmt_cancelreturn} />
    <input type="hidden" name="pmt_delayedpayreturn"           value={this.state.pmt_delayedpayreturn} />
    <input type="hidden" name="pmt_escrow"                     value={this.state.pmt_escrow} />
    <input type="hidden" name="pmt_escrowchangeallowed"        value={this.state.pmt_escrowchangeallowed} />
    <input type="hidden" name="pmt_paymentmethod"              value={this.state.pmt_paymentmethod} />
    {this.state.businessCustomer ? <React.Fragment><input type="hidden" name="pmt_buyeridentificationcode"              value={this.state.businessId} /></React.Fragment> : <React.Fragment></React.Fragment>}
    <input type="hidden" name="pmt_invoicefromseller"          value={this.state.pmt_invoicefromseller} />
    <input type="hidden" name="pmt_buyername"                  value={this.state.pmt_buyername} />
    <input type="hidden" name="pmt_buyeraddress"               value={this.state.pmt_buyeraddress} />
    <input type="hidden" name="pmt_buyerpostalcode"            value={this.state.pmt_buyerpostalcode} />
    <input type="hidden" name="pmt_buyercity"                  value={this.state.pmt_buyercity} />
    <input type="hidden" name="pmt_buyercountry"               value={this.state.pmt_buyercountry} />
    <input type="hidden" name="pmt_buyerphone"                 value={this.state.pmt_buyerphone} />
    <input type="hidden" name="pmt_buyeremail"                 value={this.state.pmt_buyeremail} />
    <input type="hidden" name="pmt_deliveryname"               value={this.state.pmt_deliveryname} />
    <input type="hidden" name="pmt_deliveryaddress"            value={this.state.pmt_deliveryaddress} />
    <input type="hidden" name="pmt_deliverypostalcode"         value={this.state.pmt_deliverypostalcode} />
    <input type="hidden" name="pmt_deliverycity"               value={this.state.pmt_deliverycity} />
    <input type="hidden" name="pmt_deliverycountry"            value={this.state.pmt_deliverycountry} />
    <input type="hidden" name="pmt_sellercosts"                value={this.state.pmt_sellercosts} />
    <input type="hidden" name="pmt_rows"                       value={this.state.pmt_rows} />
    <input type="hidden" name="pmt_row_name1"                  value={this.state.pmt_row_name1}/>
    <input type="hidden" name="pmt_row_desc1"                  value={this.state.pmt_row_desc1} />
    <input type="hidden" name="pmt_row_quantity1"              value={this.state.pmt_row_quantity1} />
    <input type="hidden" name="pmt_row_deliverydate1"          value={this.state.pmt_row_deliverydate1} />
    <input type="hidden" name="pmt_row_price_gross1"           value={this.state.pmt_row_price_gross1} />
    <input type="hidden" name="pmt_row_vat1"                   value={this.state.pmt_row_vat1} />
    <input type="hidden" name="pmt_row_discountpercentage1"    value={this.state.pmt_row_discountpercentage1} />
    <input type="hidden" name="pmt_row_type1"                  value={this.state.pmt_row_type1} />
    <input type="hidden" name="pmt_charset"                    value={this.state.pmt_charset} />
    <input type="hidden" name="pmt_charsethttp"                value={this.state.pmt_charsethttp} />
    <input type="hidden" name="pmt_hashversion"                value={this.state.pmt_hashversion} />
    <input type="hidden" name="pmt_hash"                       value={this.state.pmt_hash} />
    <input type="hidden" name="pmt_keygeneration"              value={this.state.pmt_keygeneration} />
        </form>
        </div>
      )
    }
  }

  }
}

export default ConfirmOrder;
